import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import Spinner from '@chama/ui-components/components/Spinner';
import PageContainer from '@app/containers/PageContainer';
import NotificationBar from '@chama/ui-components/components/NotificationBar';
import ConnectivitySnackBar from '@app/containers/ConnectivitySnackBar';
import MdtStatus from '@app/containers/MdtStatus';
import OrderDetails from '../../containers/OrderDetails';
import RightPanel from '../RightPanel';
import OrderPanel from '../OrderPanel/OrderPanel.connect';
import OrdersTabs from './OrdersTabs.connect';
import './index.css';

const notificationBarStyle = {
  top: '10px',
};

class OrdersLayout extends Component {
  constructor(props) {
    super(props);

    this.wasModalDismissed = false;

    /* eslint-disable react/no-unused-state */
    /** TODO: Verify if notification is being used externally through refs */
    this.state = {
      isNotificationClosed: true,
    };
  }

  componentWillReceiveProps(newProps) {
    const currentNotification = this.props.notification;
    const newNotification = newProps.notification;

    if (currentNotification.id !== newNotification.id) {
      const { message, error } = newNotification;

      this.notificationBar.notify(message, error);
      this.onNotificationOpen();
    }
  }

  onNotificationOpen = () => {
    this.setState({ isNotificationClosed: false });
  };

  onNotificationClose = () => {
    this.setState({ isNotificationClosed: true });
  };

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  renderPageLoading = () => {
    const { ticketsFetched } = this.props;

    if (!ticketsFetched) {
      return (
        <div className="OrdersLayout__page_loading_wrapper">
          <Spinner>Carregando</Spinner>
        </div>
      );
    }

    return null;
  };

  renderRighPanelContent = () => {
    const { order } = this.props;

    if (order) {
      return <OrderDetails />;
    }

    return null;
  };

  renderContent = () => {
    // when showing ticket details hide ticketlist when the screen is too small
    const {
      dealers,
      order,
      ordersFinalized,
      fetchMoreFinalizedTickets,
      ticketsFetched,
      offset,
      setCurrentOrder,
      userId,
      dismissOrder,
      cancelDelivery,
    } = this.props;

    if (!ticketsFetched) {
      return null;
    }

    const contentClass = classNames('OrdersLayout', { 'has-order_selected': !!order });

    return (
      <section className={contentClass}>
        <div className="OrdersLayout__col">
          <OrderPanel
            dealers={dealers}
            activeOrder={order}
            ordersFinalized={ordersFinalized}
            fetchMoreFinalizedTickets={fetchMoreFinalizedTickets}
            dismissOrder={dismissOrder}
            cancelDelivery={cancelDelivery}
            offset={offset}
            setCurrentOrder={setCurrentOrder}
            userId={userId}
          />
        </div>
        <div className="OrdersLayout__col">
          <div className="OrdersLayout__order_details_wrapper">
            <RightPanel>{this.renderRighPanelContent()}</RightPanel>
          </div>
        </div>
      </section>
    );
  };

  render() {
    return (
      <PageContainer title={<OrdersTabs />} subheader={MdtStatus}>
        <ConnectivitySnackBar />
        <NotificationBar
          ref={this.handleRef('notificationBar')}
          style={notificationBarStyle}
          onClose={this.onNotificationClose}
        />

        {this.renderContent()}

        <CSSTransitionGroup
          transitionName="CSSTG-fade"
          transitionEnterTimeout={375}
          transitionLeaveTimeout={300}
        >
          {this.renderPageLoading()}
        </CSSTransitionGroup>
        {/* <OrderWebNotifications /> */}
      </PageContainer>
    );
  }
}

OrdersLayout.propTypes = {
  dealers: PropTypes.object.isRequired,
  order: PropTypes.object,
  ordersFinalized: PropTypes.array.isRequired,
  fetchMoreFinalizedTickets: PropTypes.func.isRequired,
  ticketsFetched: PropTypes.bool.isRequired,
  offset: PropTypes.number.isRequired,
  setCurrentOrder: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  dismissOrder: PropTypes.func.isRequired,
  cancelDelivery: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
};

OrdersLayout.defaultProps = {
  order: null,
};

export default OrdersLayout;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrdersLayout/index.jsx